/**
 * Other-component ``quantity_mode`` is exactly one of ``panel`` | ``battery`` | ``inverter`` | ``custom_code``;
 * ``mode_step`` is 1 for per-unit and >1 for every-N.
 */

export const SCALED_OTHER_QUANTITY_MODES = ['panel', 'battery', 'inverter', 'custom_code'] as const

export type ScaledOtherQuantityMode = (typeof SCALED_OTHER_QUANTITY_MODES)[number]

const scaledModeSet = new Set<string>(SCALED_OTHER_QUANTITY_MODES)

export function otherRowModeSelectKey(raw: string | null | undefined): '' | ScaledOtherQuantityMode {
  const t = String(raw ?? '').trim().toLowerCase()
  if (!t || !scaledModeSet.has(t)) return ''
  return t as ScaledOtherQuantityMode
}

export function isScaledOtherQuantityMode(mode: string | null | undefined): boolean {
  return otherRowModeSelectKey(mode) !== ''
}
